"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AtlasEngineClient = void 0;
const ClientFactory_1 = require("./ClientFactory");
const SocketIoManager_1 = require("./Clients/Lib/SocketIoManager");
const dummyIdentity = {
    token: 'ZHVtbXlfdG9rZW4=',
    userId: 'dummy_token',
};
class AtlasEngineClient {
    constructor(atlasEngineUrl, identity) {
        this.atlasEngineUrl = atlasEngineUrl;
        this.identity = identity !== null && identity !== void 0 ? identity : dummyIdentity;
        const socketIoManager = new SocketIoManager_1.SocketIoManager(this.atlasEngineUrl);
        this.applicationInfoClient = ClientFactory_1.ClientFactory.createApplicationInfoClient(this.atlasEngineUrl, this.identity, socketIoManager);
        this.correlationClient = ClientFactory_1.ClientFactory.createCorrelationClient(this.atlasEngineUrl, this.identity);
        this.cronjobClient = ClientFactory_1.ClientFactory.createCronJobClient(this.atlasEngineUrl, this.identity);
        this.dataObjectInstanceClient = ClientFactory_1.ClientFactory.createDataObjectInstanceClient(this.atlasEngineUrl, this.identity);
        this.emptyActivityClient = ClientFactory_1.ClientFactory.createEmptyActivityClient(this.atlasEngineUrl, this.identity, socketIoManager);
        this.eventClient = ClientFactory_1.ClientFactory.createEventClient(this.atlasEngineUrl, this.identity, socketIoManager);
        this.externalTaskClient = ClientFactory_1.ClientFactory.createExternalTaskClient(this.atlasEngineUrl, this.identity);
        this.flowNodeInstanceClient = ClientFactory_1.ClientFactory.createFlowNodeInstanceClient(this.atlasEngineUrl, this.identity);
        this.manualTaskClient = ClientFactory_1.ClientFactory.createManualTaskClient(this.atlasEngineUrl, this.identity, socketIoManager);
        this.notificationClient = ClientFactory_1.ClientFactory.createNotificationClient(this.atlasEngineUrl, this.identity, socketIoManager);
        this.processDefinitionClient = ClientFactory_1.ClientFactory.createProcessDefinitionClient(this.atlasEngineUrl, this.identity);
        this.processInstanceClient = ClientFactory_1.ClientFactory.createProcessInstanceClient(this.atlasEngineUrl, this.identity);
        this.processModelClient = ClientFactory_1.ClientFactory.createProcessModelClient(this.atlasEngineUrl, this.identity);
        this.userTaskClient = ClientFactory_1.ClientFactory.createUserTaskClient(this.atlasEngineUrl, this.identity, socketIoManager);
    }
    dispose() {
        this.applicationInfoClient.dispose();
        this.correlationClient.dispose();
        this.cronjobClient.dispose();
        this.dataObjectInstanceClient.dispose();
        this.emptyActivityClient.dispose();
        this.eventClient.dispose();
        this.flowNodeInstanceClient.dispose();
        this.manualTaskClient.dispose();
        this.notificationClient.dispose();
        this.processDefinitionClient.dispose();
        this.processInstanceClient.dispose();
        this.userTaskClient.dispose();
    }
    /**
     * Gets the url of the engine that this client is communicating with.
     */
    getEngineUrl() {
        return this.atlasEngineUrl;
    }
    get applicationInfo() {
        return this.applicationInfoClient;
    }
    get correlations() {
        return this.correlationClient;
    }
    get cronjobs() {
        return this.cronjobClient;
    }
    get dataObjectInstances() {
        return this.dataObjectInstanceClient;
    }
    get emptyActivities() {
        return this.emptyActivityClient;
    }
    get events() {
        return this.eventClient;
    }
    get externalTasks() {
        return this.externalTaskClient;
    }
    get flowNodeInstances() {
        return this.flowNodeInstanceClient;
    }
    get manualTasks() {
        return this.manualTaskClient;
    }
    get notification() {
        return this.notificationClient;
    }
    get processDefinitions() {
        return this.processDefinitionClient;
    }
    get processInstances() {
        return this.processInstanceClient;
    }
    get processModels() {
        return this.processModelClient;
    }
    get userTasks() {
        return this.userTaskClient;
    }
}
exports.AtlasEngineClient = AtlasEngineClient;
//# sourceMappingURL=Client.js.map